// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p214 єдине меню робочої області — вкладки Меню / Сторінки / Завдання): пункты и пометки панели страниц стола — чистые функции,
// вынесены из components/PagesPanel.vue без изменения поведения; их же читает вкладка «Сторінки» формы меню рабочей области (components/WorkspaceMenuForm.vue)
import { t as i18n_t, getLanguage } from '@/i18n'
import { wsTaskLabel_title } from '@/utils/wsTaskLabel'
import { tipFormat_pageGroupRow } from '@/utils/tipFormat'

// пункты панели: группы страниц папками, страницы вне групп — группа «Pages»; view 'widgets' — под страницей виджеты, открываемые с ней; onlyPage — одна страница (id)
export function pagesPanel_items(store, { view = 'pages', onlyPage = '', t = i18n_t } = {}) {
    void store._favEpoch
    void store._settingsEpoch   // IE 2026 10 29 / ODOO-5800 (слово Igor 29.10: «задание рабочего стола и далее название этого стола»): выключатель fe.ux.wsTaskLabel
    const WS = store.activeWORKSPACE
    if (!WS) return []
    const ws = WS.workspace
    const withWidgets = view === 'widgets'
    const pages = Object.values(WS.PAGES || {}).filter(P => P && P.use !== false && P.node?.value && (!onlyPage || String(P.node.value) === onlyPage)).sort((a, b) => (a.ind ?? 0) - (b.ind ?? 0))
    const widgetsOf = (P) => {
        const opens = new Set(store.page_openSet(ws, P.node.value).ids)   // IE 2026 09 22 (уточнение Игоря): действующий набор открытия — личный, иначе умолчания
        const out = []
        const walk = (rows) => { for (const r of rows || []) { if (!r || r.use === false) continue; const id = r.widget || (r.node?.relation_segment ? r.node?.value : null)
            if (id && opens.has(String(id))) out.push({ title: r.node?.valueStr || r.title || String(id), cssClass: r.node?.pi || r.cssClass || 'pi pi-table', command: 'page_open', _page: P.node.value, _widget: String(id), _segment: String(r.node?.relation_segment || r.segment || ''), _row: r })
            if (r.attrs) walk(r.attrs) } }
        walk(P.attrs)
        return out
    }
    // IE 2026 09 22 (заказ Игоря, п.1): страница — «выпуклый» бейдж (класс строки menu-panel-page), текущая — currentOf
    // IE 2026 09 23 / ODOO-… (заказ Игоря: «добавь нумерацию пейджев, как на скрине 2»): num — номер страницы (store.pageRail_num: одно правило
    // счёта с Page.vue railRows) — место страницы в ПОЛНОМ списке страниц стола, есть у каждой страницы
    // IE 2026 09 24 / ODOO-… (заказ Игоря: оформление строк в панелях-меню): _row — строка настройки (страница стола / виджет страницы): MenuPanel красит пункт как её ячейку «Назва»
    // IE 2026 09 26 / ODOO-… (заказ Игоря: виды панели страниц): _tipRows — строки подсказки пункта (виджеты, открываемые со страницей, когда их не видно; до 8 названий)
    const item = (P) => {
        const ws_ = widgetsOf(P)
        const names = ws_.map(w => w.title)
        const titles = names.slice(0, 8).join(', ') + (names.length > 8 ? `, … (+${names.length - 8})` : '')
        // IE 2026 10 29 / ODOO-5800 (слово Igor 29.10: «задание рабочего стола и далее название этого стола»): страница настроек рабочей области page-settings — «Workspace task: <название рабочей области>» (номер и иконка как были; fe.ux.wsTaskLabel = false — как было) — IE 2026 11 02 / ODOO-349799 (workspace-wording)
        return { title: wsTaskLabel_title(store, WS, P, P.node.valueStr || P.title || P.node.value, getLanguage(), t), cssClass: P.pi || P.node.pi || 'pi pi-desktop', tooltip: P.tooltip || '', command: 'page_open', _page: P.node.value,
            num: store.pageRail_num(ws, P.node.value), 'cssClass-row': 'menu-panel-page', attrs: withWidgets ? ws_ : [], _row: P,
            _tipRows: withWidgets ? null : { [t('Widgets')]: titles || '—' } }
    }
    // страницы вне групп — одна группа «Pages» (на месте первой из них): пункт с виджетами под ним иначе стал бы отдельной группой
    const out = []
    let grp = null, plain = null
    for (const P of pages) {
        const g = P.group
        if (g?.key) {
            // IE 2026 09 25 / ODOO-… (заказ Игоря: форматирование строк из подсказки): _group / _row — ключ и строка-группа записи стола (WS.record.doc.pages): заголовок группы красится её оформлением, подсказка получает кнопки цвета / фона
            if (!grp || grp._key !== g.key) { grp = { title: g.title || g.key, node: { value: 'grp:' + g.key, valueStr: g.title || g.key, attr_type: 'AttrStr' }, attrs: [], _key: g.key, _group: g.key, _row: tipFormat_pageGroupRow(store, ws, g.key) }; out.push(grp) }
            grp.attrs.push(item(P))
        } else {
            grp = null
            if (!plain) { plain = { title: t('Pages'), node: { value: 'grp:pages', valueStr: t('Pages'), attr_type: 'AttrStr' }, attrs: [] }; out.push(plain) }
            plain.attrs.push(item(P))
        }
    }
    return out
}

export function pagesPanel_currentOf(store, raw) { return !!raw && !!raw._page && !raw._widget && raw._page === store.activeWORKSPACE?.active_page }
export function pagesPanel_favOf(store, raw) {
    if (!raw || !raw._page || raw._widget) return null
    const WS = store.activeWORKSPACE
    return !!WS && store.favorites_pages(WS.workspace).includes(String(raw._page))
}
export function pagesPanel_homeOf(store, raw) {
    if (!raw || !raw._page || raw._widget) return null
    const WS = store.activeWORKSPACE
    return !!WS && store.favorites_defaultPage(WS.workspace) === String(raw._page)
}
export function pagesPanel_fav(store, raw, on) { const WS = store.activeWORKSPACE; if (WS && raw?._page) store.favorites_togglePage(WS.workspace, raw._page, on) }
export function pagesPanel_home(store, raw, on) { const WS = store.activeWORKSPACE; if (WS && raw?._page) store.favorites_setDefaultPage(WS.workspace, raw._page, on) }
// выбор пункта: страница — переход; виджет под открытой страницей — открыть / активировать его (vueObj — владелец действия, если активного виджета нет)
export function pagesPanel_pick(store, raw, vueObj) {
    const WS = store.activeWORKSPACE
    if (!WS || !raw?._page) return
    if (raw._widget && raw._page === WS.active_page) {   // страница уже открыта — открыть / активировать виджет
        store.executeStoreMethod(store.activeWIDGET?.vueObj || vueObj, { command: 'widget_open', widget: raw._widget, workspace: WS.workspace, page: raw._page })
        return
    }
    if (raw._page !== WS.active_page) store.workspace_open(WS.workspace, raw._page)
}
// строка футера: спрятать / показать рейл страниц (store.pagesRail_toggle)
export function pagesPanel_railFooter(store, t = i18n_t) {
    return [{ id: 'railToggle', icon: 'pi ie-ico-sidebar', label: store.pagesRailHidden ? t('Show pages rail') : t('Hide pages rail'), help: 'topbar.rail.toggle',
        vars: { menuRow: true }, state: () => (store.pagesRailHidden ? 'hidden' : 'shown') }]
}

export default { pagesPanel_items, pagesPanel_currentOf, pagesPanel_favOf, pagesPanel_homeOf, pagesPanel_fav, pagesPanel_home, pagesPanel_pick, pagesPanel_railFooter }
